import { configureStore } from '@reduxjs/toolkit';
import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { persistedClientReducer } from 'src/redux/client/clientRootReducer';

const clientStore = configureStore({
  reducer: persistedClientReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const clientPersistor = persistStore(clientStore);
const clientDispatch = clientStore.dispatch;

export { clientStore, clientPersistor, clientDispatch };
